import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { HubSpotCtaBlock } from '../types';
import { HubSpotCtaLoader } from '@/components/blocks/external-embed-shell/HubSpotCtaLoader';
import styles from './HubSpotForm.module.css';
interface HubSpotCtaProps {
  block: HubSpotCtaBlock;
  blockId: string;
}
export function HubSpotCta(t0) {
  const $ = _c(6);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.contentId || $[1] !== block.portalId) {
    t1 = <HubSpotCtaLoader portalId={block.portalId} ctaId={block.contentId} />;
    $[0] = block.contentId;
    $[1] = block.portalId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== blockId || $[4] !== t1) {
    t2 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="hubspotCta">{t1}</div>;
    $[3] = blockId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}